module.exports = __webpack_public_path__ + "img/9791189336189.4d5bb929.jpg";